import "./instantsearch.js";
import "./billboard-slideshow.js";
import "./accordion.js";
import "./foxy-login.js";
import "./buy-button-anchor.js";
import "./scripts.js";
import featherlight from 'featherlight/src/featherlight.js';

/*
MC Validate
 */
// import "./js/vendor/mc-validate.js";
// import "./js/vendor/footer-form.js";

//Import Classes
import InstantSearch from "./instantsearch.js";

const instantSearch = new InstantSearch(document.getElementById('supafolio-v3-search'));


instantSearch.instantSearch();



